export default function validFileSize(file, setFileError, maxSize = 10) {
  const size = (file.size / 1024 / 1024).toFixed(4)
  if (Math.round(size * 10) / 10 >= maxSize) {
    setFileError(`The file is too large; it should be under ${maxSize} MB.`)
    return false
  }
  setFileError(null)
  return true
}
